import { render, staticRenderFns } from "./ManualNikudPane.vue?vue&type=template&id=9575ed2c&scoped=true&"
import script from "./ManualNikudPane.vue?vue&type=script&lang=js&"
export * from "./ManualNikudPane.vue?vue&type=script&lang=js&"
import style0 from "./ManualNikudPane.vue?vue&type=style&index=0&id=9575ed2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9575ed2c",
  null
  
)

export default component.exports